import Vue from"vue";Vue.filter("arrayFirst",(function(r){return console.warn("arrayFirst is a deprecated vue filter!"),r[0]}));